// Function to add a product to the cart
const addProductsToCart = async (cart, productIds, cartDrawer, rewardAvailable) => {
  let productsToAdd = [];
  for (let i = 0; i < productIds.length; i++) {
    if (rewardAvailable[i] && !cart.items.some((item) => item.id === productIds[i])) {
      productsToAdd.push(productIds[i]);
    }
  }

  if (productsToAdd.length === 0) {
    return; // Exit the function if all the products are already in the cart
  }


  const productData = {
    items: productsToAdd.map((productId) => ({
      id: productId,
      quantity: 1,
      properties: {
        _reward: "true",
      },
    })),
  };

  const config = fetchConfig("json");
  config.headers["X-Requested-With"] = "XMLHttpRequest";

  if (cartDrawer) {
    productData.sections = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    productData.sections_url = window.location.pathname;
    cartDrawer.setActiveElement(document.activeElement);
  }

  config.body = JSON.stringify(productData);

  fetch(window.routes.cart_add_url + `.js`, config)
    .then((response) => response.json())
    .then((data) => {
      cartDrawer.classList.remove("is-empty");
      cartDrawer.renderContents(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

// Function to remove multiple products from the cart
const removeProductsFromCart = async (cart, productIds, cartDrawer) => {
  const productsToRemove = cart.items.filter((item) =>
    productIds.includes(item.id)
  );

  if (productsToRemove.length === 0) {
    return; // Exit the function if none of the products are in the cart
  }

  const updates = productsToRemove.reduce((acc, item) => {
    acc[item.key] = 0; // Set quantity to 0 to remove the item
    return acc;
  }, {});

  const requestBody = {
    updates,
  };

  const config = fetchConfig("json");
  config.headers["X-Requested-With"] = "XMLHttpRequest";

  if (cartDrawer) {
    requestBody.sections = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    requestBody.sections_url = window.location.pathname;
    cartDrawer.setActiveElement(document.activeElement);
  }

  config.body = JSON.stringify(requestBody);

  await fetch(`/cart/update.js`, config)
    .then((response) => response.json())
    .then((data) => {
      if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");
        cartDrawer.renderContents(data);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

const saveRewardsDataToCart = async (rewards) => {
  const config = fetchConfig("json");
  config.body = JSON.stringify({
    attributes: {
      '_rewards_data': JSON.stringify({
        reward_products: [rewards.reward_one, rewards.reward_two, rewards.reward_three],
        reward_thresholds: [rewards.reward_sum_two, rewards.reward_sum_three, rewards.reward_sum_four],
        reward_available: [rewards.reward_available_one, rewards.reward_available_two, rewards.reward_available_three]
      })
    }
  });
  await fetch('/cart/update.js', config);
 
};

const ensureRewardsDataInCart = async () => {
  // Check if rewards data already exists in cart
  const cart = await fetch('/cart.js').then(r => r.json());
  // If rewards data is missing, save it now
  if (!cart.attributes._rewards_data) {
    const rewardsElement = document.querySelector("[data-rewards-data]");
    if (rewardsElement) {
      const rewards = JSON.parse(rewardsElement.textContent);
      await saveRewardsDataToCart(rewards);
    }
  }
};

// Run on cart page load
document.addEventListener('DOMContentLoaded', ensureRewardsDataInCart);

subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
  const cartDrawer =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  // Get the rewards data
  const rewardsElement = document.querySelector("[data-rewards-data]");

  const rewardsData = rewardsElement ? rewardsElement.textContent : null;
  const rewards = JSON.parse(rewardsData);

  if (rewards) await saveRewardsDataToCart(rewards);
  // Get the cart data
  const cart = await fetch("/cart.js", { method: "GET" }).then((response) =>
    response.json()
  );
  // Get the cart total price
  const cartTotalPrice = cart.total_price / 100;

  // Check the reward thresholds and add or remove products as necessary
  if (rewards) {
    const rewardThresholds = [
      rewards.reward_sum_two,
      rewards.reward_sum_three,
      rewards.reward_sum_four,
    ];
    const rewardProducts = [
      rewards.reward_one,
      rewards.reward_two,
      rewards.reward_three,
    ];
    const rewardAvailable = [
      rewards.reward_available_one,
      rewards.reward_available_two,
      rewards.reward_available_three,
    ]

    let thresholdIndex = rewardThresholds.findIndex(
      (threshold) => cartTotalPrice < threshold
    );

    if (thresholdIndex === -1) {
      thresholdIndex = rewardThresholds.length;
    }

    const productsToAdd = rewardProducts.slice(0, thresholdIndex);
    const productsToRemove = rewardProducts.slice(thresholdIndex);

    const staticItem = cart.items.find((item) => item.product_type === "static");

    if (staticItem) {
      await removeProductsFromCart(cart, [staticItem.id], cartDrawer);
    }

    const partnerProduct = cart.items.some((item) => item.vendor === "Partner product");

    if (partnerProduct) {
      await removeProductsFromCart(cart, [40614132711489, 40614238224449, 40614132809793, 14972921610588, 14974566203740], cartDrawer);
      return
    }

    if (productsToAdd.length > 0) {
      await addProductsToCart(cart, productsToAdd, cartDrawer, rewardAvailable);
    }

    if (productsToRemove.length > 0) {
      await removeProductsFromCart(cart, productsToRemove, cartDrawer);
    }


  }

  if (cart.items.length === 0) {
    cartDrawer.classList.add("is-empty");
  }
  
  // Simple cleanup: remove excess reward products
  const rewardItems = cart.items.filter(item => 
    item.properties?._reward === 'true' && item.quantity > 1
  );

  if (rewardItems.length > 0) {
    const updates = rewardItems.reduce((acc, item) => {
      acc[item.key] = 1; // Set quantity to exactly 1
      return acc;
    }, {});
    
    const requestBody = { updates };
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";

    if (cartDrawer) {
      requestBody.sections = cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      requestBody.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(requestBody);

    fetch(`/cart/update.js`, config)
      .then((response) => response.json())
      .then((data) => {
        if (cartDrawer) {
          cartDrawer.classList.remove("is-empty");
          cartDrawer.renderContents(data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } 
});